module.exports = __webpack_public_path__ + "img/icon_expect@2x.565982cf.png";